/**
 * 全局kay:value字典数据
 * 页面临时消息 tmpMsg-contact_id@cantact_source:[tmpmsg]
 */

var _globaldic = {};

module.exports = {
    get: function (key) {
        return _globaldic[key];
    },
    set: function (key, value) {
        _globaldic[key] = value;
    }
};